import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Sort from 'components/search/Sort';
import Layout from 'components/search/Layout';
import SavedSearch from 'components/search/SaveSearch';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import marketplace from 'cfg/marketplace.json';

import styles from 'styles/components/search/searchMenu.scss';
const {
  search: { sortOptions }
} = marketplace;

export class SearchMenu extends Component {
  static displayName = 'SearchMenu';

  makeFilterControl() {
    const { onToggleFacetsContainer } = this.props;
    const { testId } = this.context;
    if (this.shouldRenderControl()) {
      return (
        <button
          key="filters"
          type="button"
          className={styles.filters}
          data-test-id={testId('filterButton')}
          onClick={onToggleFacetsContainer}>
          {this.makeFilterText()}
        </button>
      );
    }
    return null;
  }

  makeFilterText() {
    const { isFacetsVisible } = this.props;
    return isFacetsVisible ? 'Close Filters' : `Filter${this.makeRenderedCount()}`;
  }

  makeLayoutControl() {
    const { selectedLayout, onLayoutSelected } = this.props;
    if (this.shouldRenderNonFilterControl()) {
      return (
        <span key="layout">
          <Layout
            tabIndex={0}
            onLayoutSelected={onLayoutSelected}
            selectedLayout={selectedLayout} />
        </span>
      );
    }
    return null;
  }

  makeMultSelectCount() {
    const { filters } = this.props;
    let multiCount = 0;
    Object.keys(filters.selected.multiSelects).filter(type => filters.selected.multiSelects[type]).forEach(filterType => {
      multiCount += filters.selected.multiSelects[filterType].length;
    });

    return multiCount;
  }

  makeRenderedCount() {
    const count = this.makeMultSelectCount();
    return count > 0 ? ` (${count})` : '';
  }

  makeSortControl(availableSortOptions = sortOptions) {
    const { filters, onSortSelected } = this.props;
    const { testId } = this.context;
    if (this.shouldRenderNonFilterControl()) {
      return (
        <span>
          <Sort
            tabIndex={0}
            sortOptions={availableSortOptions}
            onSortSelected={onSortSelected}
            selectedSort={filters.sort}
            filters={filters}
            testId={testId('selectSortValue')}
          />
        </span>
      );
    }
    return null;
  }

  shouldRenderControl() {
    const { filters: { selected, pageCount } } = this.props;
    return pageCount > 0 || (pageCount === 0 && Object.keys(selected.multiSelects).length > 0);
  }

  shouldRenderNonFilterControl() {
    const { isFacetsVisible } = this.props;
    return this.shouldRenderControl() && !isFacetsVisible;
  }

  render() {
    const { handleSavedSearch, hydraSavedSearches, products: { totalProductCount, urlMatchesSavedSearch } } = this.props;
    const { testId } = this.context;
    return (
      <div className={cn(styles.searchMenu, { [styles.hasSavedSearch]: hydraSavedSearches })}>
        <div className={styles.itemCount} data-test-id={testId('searchResultsItemCount')}>{totalProductCount} items</div>
        {hydraSavedSearches && <SavedSearch heartActive={urlMatchesSavedSearch} handleSavedSearch={handleSavedSearch} />}
        {this.makeLayoutControl()}
        {this.makeSortControl()}
        {this.makeFilterControl()}
      </div>
    );
  }
}

SearchMenu.propTypes = {
  onLayoutSelected: PropTypes.func.isRequired,
  onSortSelected: PropTypes.func.isRequired,
  onToggleFacetsContainer: PropTypes.func.isRequired,
  selectedLayout: PropTypes.string,
  filters: PropTypes.object,
  products: PropTypes.object,
  isFacetsVisible: PropTypes.bool
};

SearchMenu.contextTypes = {
  testId: PropTypes.func
};

export default withErrorBoundary('SearchMenu', SearchMenu);
